<template>
  <el-button type="info" plain @click="goBackToList">
    <el-icon><Fold /></el-icon>
    返回列表
  </el-button>

  <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">

    <el-tab-pane label="目录" name="menu">
      <ChapterComponents/>
    </el-tab-pane>
    <el-tab-pane label="考试管理" name="exam">
      <ExamList/>
    </el-tab-pane>
    <el-tab-pane label="作业管理" name="homework">
      <HomeworkList/>
    </el-tab-pane>
    <el-tab-pane label="课程介绍" name="introduce">
      <IntroCourseComponents/>
    </el-tab-pane>
  </el-tabs>
</template>
  
  <script setup>
import { ref } from "vue";
import ChapterComponents from '@/components/course/chapter/ChapterComponents.vue';
import IntroCourseComponents from '@/components/course/IntroCourseComponents';
import HomeworkList from '@/components/course/homework/HomeworkList'
import ExamList from '@/components/course/exam/ExamList'

const activeName = ref("menu");

const handleClick = (tab, event) => {
  console.log(tab, event);
}


const goBackToList = () => {
  window.history.back();
}
</script>
  
  <style scoped>
.demo-tabs > .el-tabs__content {
  padding: 32px;
  color: #6b778c;
  font-size: 32px;
  font-weight: 600;
}

</style>